const SwedenFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="30" height="20" fill="#006AA7"/>
    <rect x="10" width="10" height="20" fill="#FECC00"/>
    <rect y="8" width="30" height="4" fill="#FECC00"/>
  </svg>
);

export default SwedenFlag;